import nazwaCzesci from '@components/search/inputs/nazwaCzesci'
import stanCzesci from '@components/search/inputs/stanCzesci'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import pojazdCzesci from '@components/search/inputs/pojazdCzesci'
import markaCzesci from '@components/search/inputs/markaCzesci'
import rodzajCzesci from '@components/search/inputs/rodzajCzesci'

import cena from '@components/search/inputs/cena'
import numerReferencyjnyCzesci from '@components/search/inputs/numerReferencyjnyCzesci'
import wystawcaCzesci from '@components/search/inputs/wystawcaCzesci'

import felgi from '@components/search/inputs/conditional/felgi'
import kola from '@components/search/inputs/conditional/kola'
import opony from '@components/search/inputs/conditional/opony'

const partFormInputsMobile = [
    nazwaCzesci,
    rodzajCzesci,
    pojazdCzesci,
    markaCzesci,
    lokalizacja,
    stanCzesci,
]

const partFormInputs = [
    nazwaCzesci,
    stanCzesci,
    lokalizacja,
    pojazdCzesci,
    markaCzesci,
    rodzajCzesci,
]

const partAdvancedInputs = [
    { inputs: [
        cena,
        numerReferencyjnyCzesci,
        wystawcaCzesci,
        felgi,
        kola,
        opony,
    ]}
]

export {
    partFormInputsMobile,
    partFormInputs,
    partAdvancedInputs,
}